import React from 'react';
import type { IMessageDialogProps } from './DialogConfig';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

import styles from './MessageDialog.module.scss';
import { Refresh } from '@mui/icons-material';
import InfoDialog from './InfoDialog';
import { Button, DialogActions } from '@mui/material';

/**
 * Component that shows a configurable menu structure in a Microsoft-Office-like structure.
 */
const dialog: React.FC<IMessageDialogProps> = ({
    title,
    description,
    type,
    children,
    closeButtonIcon,
    closeButtonText,
    closeFn,
}) => {
    const drawIcon = () => {
        if (type === 'generic') {
            return null;
        }

        switch (type) {
            case 'error':
                return <WarningRoundedIcon className={styles.errorIcon} />;
            case 'info':
                return <InfoOutlinedIcon className={styles.infoIcon} />;
            case 'loading':
                return <Refresh className={styles.loadingIcon} />;
            case 'warning':
                return <WarningAmberRoundedIcon className={styles.warningIcon} />;
        }
    };

    return (
        <InfoDialog open={true} title={title} text={description}>
            {drawIcon()}
            {children}
            <DialogActions>
                <Button autoFocus onClick={closeFn} startIcon={closeButtonIcon}>
                    {closeButtonText}
                </Button>
            </DialogActions>
        </InfoDialog>
    );
};

export default dialog;
